module.exports = __webpack_public_path__ + "static/work30-8d858073e6bcf88b213e4f59b17b2d20.jpg";